import React, { SVGProps } from 'react';

export const Scissors = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.083 5.377C6.345 4.98 6.5 4.509 6.5 4c0-1.379-1.121-2.5-2.5-2.5A2.503 2.503 0 0 0 1.5 4c0 1.379 1.121 2.5 2.5 2.5.509 0 .981-.155 1.377-.417L7.293 8 5.377 9.917A2.484 2.484 0 0 0 4 9.5 2.503 2.503 0 0 0 1.5 12c0 1.379 1.121 2.5 2.5 2.5s2.5-1.121 2.5-2.5c0-.509-.155-.981-.417-1.377L8 8.707l4.98 4.98a.499.499 0 1 0 .707-.708L6.083 5.377ZM4 13.5c-.827 0-1.5-.673-1.5-1.5a1.501 1.501 0 0 1 2.56-1.06h.001A1.501 1.501 0 0 1 4 13.5ZM2.5 4c0-.827.673-1.5 1.5-1.5a1.501 1.501 0 0 1 1.061 2.56H5.06v.001A1.501 1.501 0 0 1 2.5 4Zm6.813 2.687a.5.5 0 0 1 0-.708l3.667-3.666a.5.5 0 1 1 .707.707l-3.666 3.667a.499.499 0 0 1-.708 0Z"
    />
  </svg>
);
